import React from 'react'

/**
 * Displays the corresponding deduction rule where items and production rules
 * can be dropped.
 */
export function TagEarleyPrefixValidInitialize() {
    return (<div className='deduction-rule'>
        <div className='rule-name'>Initialize:</div>
        <div className='middle-rule-part'>
            <hr/>
            <div
                className='consequence'><span className={'unbreakable'}>[α, ε, la, 0, 0, -, -, 0, 0]</span>
            </div>
        </div>
        <div className='side-condition'><span className={'unbreakable'}>α ∈ I, l(α, ε) = S</span></div>
    </div>)
}
